var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Video-Visit-3",
    transform: "translate(-465.000000, -361.000000)",
    fill: "#516983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(464.999907, 355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 5.999907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6060338,8.9930762 C16.6060338,9.06812306 16.5630503,9.10808609 16.5270371,9.12853229 C16.4907915,9.14874615 16.4345645,9.16477783 16.3699731,9.12644121 L13.6740948,7.75073707 L13.6740948,3.92079163 L16.3269896,2.56901885 L16.3699731,2.54531984 C16.4343321,2.50675087 16.4907915,2.52278255 16.5270371,2.54299641 C16.5630503,2.56344261 16.6060338,2.60363799 16.6060338,2.67868484 L16.6060338,8.9930762 Z M12.2800356,9.68708537 C12.2800356,10.0128305 12.0151643,10.2774695 11.6896515,10.2774695 L1.98444334,10.2774695 C1.6589305,10.2774695 1.39405925,10.0128305 1.39405925,9.68708537 L1.39405925,1.98444334 C1.39405925,1.6589305 1.6589305,1.39405925 1.98444334,1.39405925 L11.6896515,1.39405925 C12.0151643,1.39405925 12.2800356,1.6589305 12.2800356,1.98444334 L12.2800356,3.066698 L12.2800356,8.6048307 L12.2800356,9.68708537 Z M17.2129142,1.32946784 C16.7284786,1.05576754 16.1557526,1.05855566 15.6752669,1.33667047 L13.6740948,2.35642481 L13.6740948,1.98444334 C13.6740948,0.890106829 12.783988,0 11.6896515,0 L1.98444334,0 C0.890339173,0 0,0.890106829 0,1.98444334 L0,9.68708537 C0,10.7814219 0.890339173,11.6715287 1.98444334,11.6715287 L11.6896515,11.6715287 C12.783988,11.6715287 13.6740948,10.7814219 13.6740948,9.68708537 L13.6740948,9.31533623 L15.6754992,10.3350906 C15.9178332,10.4754259 16.1836338,10.5455935 16.4498991,10.5455935 C16.7112852,10.5455935 16.9729037,10.4779816 17.2131466,10.3420609 C17.7059465,10.063249 18.000093,9.5592966 18.000093,8.9930762 L18.000093,2.67868484 C18.000093,2.11246445 17.7057142,1.60804734 17.2129142,1.32946784 L17.2129142,1.32946784 Z",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.c02e1b1c70452445799cd202a1be4cdc.svg";
export { ForwardRef as ReactComponent };